<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="getListData">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.orderNo"
            placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="订单状态：">
          <el-select v-model.number="formInline.state" placeholder="请选择订单状态" size="small" @change="getListData">
            <el-option v-for="item in stateList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否预警：">
          <el-select v-model.number="formInline.isWarningQuJing" placeholder="请选择是否预警" size="small"
            @change="getListData">
            <el-option label="全部" :value="0" :key="0"></el-option>
            <el-option label="预警" :value="1" :key="1"></el-option>
            <el-option label="未预警" :value="2" :key="2"></el-option>
            <el-option label="超期" :value="3" :key="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单来源：">
          <el-select v-model.number="formInline.orderSource" placeholder="请选择订单来源" size="small" @change="getListData">
            <el-option v-for="item in orderSourceList" :label="item.name" :value="item.code"
              :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型：">
          <el-select v-model.number="formInline.orderType" placeholder="请选择订单类型" size="small" @change="getListData">
            <el-option v-for="item in orderTypeList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加工渠道：">
          <el-select v-model.number="formInline.machinChannel" placeholder="请选择加工渠道" size="small" @change="getListData">
            <el-option v-for="item in machinChannelList" :label="item.name" :value="item.code"
              :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核类型：">
          <el-select v-model.number="formInline.auditType" placeholder="请选择审核类型" size="small" @change="getListData">
            <el-option v-for="item in auditTypeList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾客姓名：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerName"
            placeholder="请输入顾客姓名"></el-input>
        </el-form-item>
        <el-form-item label="顾客电话：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerPhone"
            placeholder="请输入顾客电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/jgborder/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/jgborder/index', 'reset')" size="small" icon="el-icon-refresh"
            @click="clearAll">重置</el-button>
          <el-button v-if="this.$checkBtnPermission('/jgborder/index', 'highFilter')" size="small" plain
            icon="el-icon-search" @click="handleFilter()">高级筛选</el-button>
          <el-button v-if="
            this.$checkBtnPermission(
              '/jgborder/index',
              'batchInputJiaGongBuKDNo'
            )
          " size="small" type="primary" class="el-icon-s-promotion" @click="handleBatchInputJiaGongBuKDNo()">批量录入快递单号
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/jgborder/index', 'updateMachinChannel')" size="small"
            type="primary" class="el-icon-s-promotion" @click="handleVisableUpdateMachinChannel()">修改加工渠道
          </el-button>
          <my-column-filter v-if="this.$checkBtnPermission('/jgborder/index', 'myFilter')" :listColumns="listColumns"
            @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @selection-change="handleSelectionChange" border>
        <el-table-column align="center" slot="orderNo" label="订单编号" width="250" fixed="left">
          <template slot-scope="scope">
            <el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">
              {{ scope.row.orderNo }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="days" label="天数" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.days <= delayDays && scope.row.days >= 0" class="one_1">
              {{ scope.row.days }}
            </span>
            <span v-else-if="scope.row.days < 0" class="one_2">
              {{ scope.row.days }}
            </span>
            <span v-else>
              {{ scope.row.days }}
            </span>
          </template>
        </el-table-column>
        <el-table-column slot="storeKDNo" label="门店快递单号" width="180">
          <template slot-scope="scope">
            <el-link v-if="scope.row.storeKDNo" type="primary" size="small"
              @click="openNewWindowSearchKuaiDi(scope.row.storeKDNo)">
              {{ scope.row.storeKDNo }}
            </el-link>
            <span v-else>
              {{ scope.row.storeKDNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column slot="storeKDNo" label="加工部快递单号" width="180">
          <template slot-scope="scope">
            <el-link v-if="scope.row.jgbkdNo" type="primary" size="small"
              @click="openNewWindowSearchKuaiDi(scope.row.jgbkdNo)">
              {{ scope.row.jgbkdNo }}
            </el-link>
            <span v-else>
              {{ scope.row.jgbkdNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="linkOrderNo" label="原订单号" width="230">
          <template slot-scope="scope">
            <el-link type="primary" size="small" @click="handleSeeYuanDetail(scope.row)">
              {{ scope.row.linkOrderNo }}
            </el-link>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <filterMore ref="filterMore" @filterMoreCallBack="filterMoreCallBack"></filterMore>
    <detail ref="detail"></detail>
    <selectGoods ref="selectGoods" :isSelectDuShu="true"></selectGoods>
    <!-- 批量录入快递单号 -->
    <el-dialog :visible.sync="dialogVisible" title="批量录入快递单号" style="width: 60%; margin: auto"
      :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong>快递单号:</strong></span>
      <el-input v-model="kdNo" placeholder="请输入快递单号" maxlength="30" show-word-limit></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleKDNoSubmit">确认</el-button>
      </span>
    </el-dialog>
    <!-- 修改订单加工渠道 -->
    <el-dialog :visible.sync="dialogVisibleUpdateMachinChannel" title="修改订单加工渠道" style="width: 60%; margin: auto"
      :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong>加工渠道:</strong></span>
      <el-select v-model.number="selectMachinChannel" placeholder="请选择加工渠道" size="small">
        <el-option v-for="item in selectMachinChannelList" :label="item.name" :value="item.code"
          :key="item.code"></el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="dialogVisibleUpdateMachinChannel = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateMachinChannel">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetStoreOrderPageList,
  BatchSaveJGBKDNo,
  UpdateMachinChannel,
} from "@/api/storeOrderApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";
import detail from "./jgbDetail.vue";
import selectGoods from "@/views/baseData/goods/selectGoods.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "订单列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      selectionRowKeyIds: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        customerPhone: "",
        customerName: "",
        startTime: "",
        endTime: "",
        belongStoreKeyId: "",
        orderNo: "",
        storeKDNo: "",
        jgbkdNo: "",
        state: 0,
        orderSource: 0,
        isWarningQuJing: 0,
        days: 1,
        machinChannel: 0,
        auditType: 0,
        orderType: 0,
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "keyId",
          label: "全选",
          align: "center",
          fixed: "left",
          width: "55",
          isKeep: true,
          selection: true,
        },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "80",
        },
        {
          prop: "belongStoreName",
          label: "所属门店",
          fixed: "left",
          isKeep: true,
          width: "150",
          align: "center",
        },
        {
          prop: "customerInfo.name",
          label: "顾客姓名",
          fixed: "left",
          width: "100",
          align: "center",
        },
        {
          slot: "orderNo",
          label: "订单编号",
          fixed: "left",
          isKeep: true,
          width: "100",
        },
        {
          prop: "stateStr",
          label: "订单状态",
          fixed: "left",
          isKeep: true,
          width: "100",
          align: "center",
        },
        {
          prop: "orderTypeStr",
          label: "订单类型",
          fixed: "left",
          isKeep: true,
          width: "100",
          align: "center",
        },
        {
          prop: "orderDate",
          label: "下单日期",
          width: "100",
          align: "center",
        },
        {
          prop: "getOrderDate",
          label: "取镜时间",
          width: "100",
          align: "center",
        },
        {
          slot: "days",
          label: "天数",
          width: "60",
          align: "center",
        },
        {
          prop: "eyeGlassTypeStr",
          label: "镜片类型",
          width: "120",
          align: "center",
        },
        {
          prop: "customerInfo.phone",
          label: "顾客电话",
          width: "130",
          align: "center",
        },
        {
          prop: "yanGuangShi",
          label: "验光师",
          width: "100",
          align: "center",
        },
        {
          prop: "jjInformation",
          label: "镜架信息",
          minWidth: "150",
          align: "center",
        },
        {
          prop: "machinTypeStr",
          label: "加工类型",
          minWidth: "100",
          align: "center",
        },
        {
          prop: "machinChannelStr",
          label: "加工渠道",
          minWidth: "100",
          align: "center",
        },
        {
          prop: "auditTypeStr",
          label: "审核类型",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "auditUserName",
          label: "审核人",
          minWidth: "80",
          align: "center",
        },
        {
          prop: "auditTime",
          label: "审核时间",
          minWidth: "160",
          align: "center",
        },
        {
          slot: "storeKDNo",
          label: "门店快递单号",
          width: "220",
        },
        {
          slot: "jgbkdNo",
          label: "加工部快递单号",
          width: "220",
        },
        {
          slot: "linkOrderNo",
          label: "原订单号",
          width: "230",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "100",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "160",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "100",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          width: "160",
        },
      ],
      chooseTime: "",
      storeList: [],
      stateList: [],
      orderTypeList: [],
      auditTypeList: [],
      orderSourceList: [],
      dialogVisible: false,
      kdNo: "",
      machinChannelList: [],
      selectMachinChannelList: [],
      selectMachinChannel: 1,
      dialogVisibleUpdateMachinChannel: false,
    };
  },
  // 注册组件
  components: {
    detail,
    selectGoods
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.GetSystemBusinessConfigDetailByCode();
    this.GetMachinChannelEnumConfigListByCode();
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetEnumConfigListByCode();
    this.GetOrderSourceEnumConfigListByCode();
    this.GetAuditTypeEnumConfigListByCode();
    this.GetOrderTypeListByCode();
  },
  computed: {},
  methods: {
    handleFilter() {
      let initForm = {
        initSearch: {
          pageIndex: 1,
          pageSize: 10,
        },
        formList: [
          {
            label: "下单日期：",
            datePickerIsRange: true,
            startProp: "startTime",
            endProp: "endTime",
            valueFormat: "yyyy-MM-dd",
            pickerType: "daterange",
          },
          {
            label: "门店快递号：",
            prop: "storeKDNo",
            input: true,
          },
          {
            label: "加工部快递号：",
            prop: "jgbkdNo",
            input: true,
          },
        ],
      };
      this.$refs.filterMore.filterShow(this.formInline, initForm);
    },
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changeTime(val) {
      if (val !== null) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    changePages() { },
    // 获取预警天数
    GetSystemBusinessConfigDetailByCode() {
      GetSystemBusinessConfigDetailByCode({
        code: 'QuJingWarningDay',
      }).then((res) => {
        if (res.code == 1) {
          this.delayDays = parseInt(res.data.delayDays) || 1;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      if (this.formInline.startTime == "") {
        this.formInline.startTime = null;
      }
      if (this.formInline.endTime == "") {
        this.formInline.endTime = null;
      }
      GetStoreOrderPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          this.storeList = [];
          if (res.code == 1) {
            res.data.forEach((item) => {
              this.storeList.push({
                keyId: item.keyId,
                value: item.name + '【' + item.remark2 + '】',
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    //获取状态信息
    GetEnumConfigListByCode() {
      const paramer = {
        code: "StoreOrderState",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.stateList = [];
            res.data.forEach((item) => {
              this.stateList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.stateList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    //获取订单类型信息
    GetOrderTypeListByCode() {
      const paramer = {
        code: "OrderType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.orderTypeList = [];
            res.data.forEach((item) => {
              this.orderTypeList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.orderTypeList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    //获取订单来源信息
    GetOrderSourceEnumConfigListByCode() {
      const paramer = {
        code: "StoreOrderSource",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.orderSourceList = [];
            res.data.forEach((item) => {
              this.orderSourceList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.orderSourceList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取订单来源信息失败!");
        });
    },
    // 获取加工渠道信息
    GetMachinChannelEnumConfigListByCode() {
      const paramer = {
        code: "MachinChannel",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.machinChannelList = [];
            this.selectMachinChannelList = [];
            res.data.forEach((item) => {
              this.machinChannelList.push({
                code: parseInt(item.code),
                name: item.name,
              });
              this.selectMachinChannelList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.machinChannelList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取加工渠道信息失败!");
        });
    },
    //获取审核类型信息
    GetAuditTypeEnumConfigListByCode() {
      const paramer = {
        code: "StoreAuditType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.auditTypeList = [];
            res.data.forEach((item) => {
              this.auditTypeList.push({
                code: parseInt(item.code),
                name: item.name,
              });
            });
            this.auditTypeList.unshift({
              code: 0,
              name: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取审核类型信息失败!");
        });
    },
    // 高级筛选回调
    filterMoreCallBack(params) {
      this.formInline = params;
      this.search();
    },
    // 查看详情
    handleSeeDetail(row) {
      this.$refs.detail.showSeeDetailDialog(row, 1);
    },
    // 查看原订单详情
    handleSeeYuanDetail(row) {
      this.$refs.detail.showSeeDetailDialog(row, 2);
    },
    // 加工部批量录入快递单号
    handleBatchInputJiaGongBuKDNo() {
      if (this.selectionRowKeyIds.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.dialogVisible = true;
    },
    handleKDNoSubmit() {
      if (this.kdNo === "") {
        this.$message.error("请输入快递单号");
        return;
      }
      let params = {
        keyIds: this.selectionRowKeyIds,
        kdNo: this.kdNo,
      };
      BatchSaveJGBKDNo(params).then((res) => {
        if (res.code === 1) {
          this.$message({
            type: "success",
            message: "快递单号录入成功！",
          });
          this.kdNo = "";
          this.dialogVisible = false;
          this.getListData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 选择行
    handleSelectionChange(val) {
      this.selectionRowKeyIds = val.map((item) => item.keyId);
    },
    //打开新窗口查询快递信息
    openNewWindowSearchKuaiDi(val) {
      if (val.startsWith("SF")) {
        window.open("https://www.sf-express.com/chn/sc/waybill/waybill-detail/" + val);
      }
      else {
        this.$message({
          type: "error",
          message: "不是顺丰单号，不支持快递信息查询！",
        });
      }
    },
    //展示选择商品
    showSelectGoods(type, paramsKeyId1, paramsKeyId2) {
      this.$refs.selectGoods.showSelectGoodsDialog(type, paramsKeyId1, paramsKeyId2);
    },
    // 选中商品
    chooseGoods(selectionList) {
      this.$refs.detail.submitSelectGoods(selectionList);
    },
    // 修改订单加工渠道
    handleUpdateMachinChannel() {
      if (this.selectionRowKeyIds.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      if (this.selectMachinChannel == 0) {
        this.$message.error("请选择加工渠道");
        return;
      }
      let params = {
        keyIds: this.selectionRowKeyIds,
        machinChannel: this.selectMachinChannel,
      };
      UpdateMachinChannel(params).then((res) => {
        if (res.code === 1) {
          this.$message({
            type: "success",
            message: "加工渠道修改成功！",
          });
          this.getListData();
          this.dialogVisibleUpdateMachinChannel = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 展示修改加工渠道弹窗
    handleVisableUpdateMachinChannel() {
      if (this.selectionRowKeyIds.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.dialogVisibleUpdateMachinChannel = true;
    },
  },
};
</script>

<style scoped>
.one_1 {
  background-color: rgb(250, 121, 1);
  display: block;
  color: white;
  font-weight: bolder;
}

.one_2 {
  background-color: rgb(255, 0, 0);
  display: block;
  color: white;
  font-weight: bolder;
}
</style>